import React, { Fragment } from 'react';
import './loggedOut.css';

const AboutUs = () => {
return (
    <div className="logged-out">
    <Fragment>
        <section className="about-hero scene scene--hero page-hero">
            <div className="container">
                <div className="hero-grid">
                    <div className="hero-copy">
                        <h1 className="display-5 mb-3">About us</h1>
                        <p className="lead">
                            Beyond Community Access was founded in 2020, by our founder - Jacob, as an answer to an obvious and painful need for highly customised supports, particularly around community access, outdoors and recreation programs.
                        </p>
                    </div>
                    <div className="hero-media text-center">
                        <div className="image-shell image-shell--hero">
                            <img
                                src="/marketing_images/about_us/3.png"
                                alt="Beyond Community Access community support"
                                className="img-fluid"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="about-content scene scene--paper story-band">
            <div className="container">
                <div className="story-card">
                    <p className="mb-4">
                       At the time, the disability support space had a fundamental lack of high-quality supports, dedicated to person centred activities in the community. Hence the name - Beyond Community Access, was chosen to convey the need for a support work agency who went above and beyond the normal 'community access' program.
                    </p>

                    <div className="row my-5 align-items-center">
                        <div className="col-md-6 mb-4 mb-md-0">
                            <div className="image-shell">
                                <img
                                    src="/marketing_images/about_us/7.png"
                                    alt="Individualised support in action"
                                    className="img-fluid"
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <p className="mb-5">
                                BCA has since grown, and seen enormous success in that space, and naturally ventured into other kinds of supports. We kept the highly individualised, customised supports - and applied that framework to all aspects of supports. Since then - Beyond Community Access has provided over 30,000 hours of support to our amazing clientele all over South Australia.
                            </p>
                            <p>
                                What started as one guy, who wanted to do better with his clients, has turned into a team of 13+ support workers, each with different specialties. Being able to apply the same highly customised support framework across many different staff interest led programs.
                            </p>
                        </div>
                    </div>

                    <p className="mb-0">
                        Beyond Community Access is a constantly evolving support agency and is still experiencing the same high level of demand, and growth to this day. Our supports speak for themselves, and with such individualised supports, measuring success is easy. With carefully curated goals of support, BCA works collaboratively with key stakeholders to ensure that our support is closely matching the clients desired outcomes.
                    </p>
                </div>
            </div>
        </section>

        <section className="about-footer scene scene--soft py-6">
            <div className="container text-center">
                <div className="image-shell image-shell--wide">
                    <img
                        src="/marketing_images/about_us/8.png"
                        alt="Beyond Community Access outdoor and community programs"
                        className="img-fluid"
                    />
                </div>
            </div>
        </section>
    </Fragment>
    </div>
);

}

export default AboutUs;
